import type { TError } from '@onesource/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';

interface NotifyGcsUploadInput {
  uploadId: string;
  blockId: string;
}

export const useNotifyGcsUpload = () => {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, TError, NotifyGcsUploadInput>({
    mutationFn: async ({ uploadId }) => {
      const res = await axios.post<{ ok: true }>(`/community-hub/gcs-uploads/${uploadId}/notify`);
      return res.data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [ENTITY, 'gcs-uploads', 'block', variables.blockId] });
    },
  });
};
